import { render, staticRenderFns } from "./BorrarCodigo.vue?vue&type=template&id=354215cf"
import script from "./BorrarCodigo.vue?vue&type=script&lang=js"
export * from "./BorrarCodigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports